<template>
  <v-app :class="!this.$vuetify.breakpoint.mobile ? '' : 'captcha-mobile mobile-view'">
    <component :is="layout">
      <router-view></router-view>
    </component>
  </v-app>
</template>

<script>
const defaultLayout = "blank";
export default {
  name: "App",
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
  },
};
</script>

<style>

</style>
